import { Navigate, useRoutes } from 'react-router';

import AdminLayout from './pages/admin/AdminLayout/AdminLayout';
import AdminGameCreate from './pages/admin/AdminGameCreate/AdminGameCreate';
import AdminGameList from './pages/admin/AdminGameList/AdminGameList';
import AdminGameUpdate from './pages/admin/AdminGameUpdate/AdminGameUpdate';
import AdminParentGameCreate from './pages/admin/AdminParentGameCreate/AdminParentGameCreate';
import AdminParentGameList from './pages/admin/AdminParentGameList/AdminParentGameList';
import AdminParentGameUpdate from './pages/admin/AdminParentGameUpdate/AdminParentGameUpdate';
import AdminSupportUpdate from './pages/admin/AdminSupportUpdate/AdminSupportUpdate';
import AdminSupportCreate from './pages/admin/AdminSupportCreate/AdminSupportCreate';
import AdminSupportList from './pages/admin/AdminSupportList/AdminSupportList';
import AdminBannerList from './pages/admin/AdminBannerList/AdminBannerList';
import AdminBannerCreate from './pages/admin/AdminBannerCreate/AdminBannerCreate';
import AdminBannerUpdate from './pages/admin/AdminBannerUpdate/AdminBannerUpdate';
import NotFound from './components/site/NotFound/NotFound';

import AdminOrderList from './pages/admin/AdminOrderList/AdminOrderList';
import AdminLogin from './pages/admin/AdminLogin/AdminLogin';
import AdminUserList from './pages/admin/AdminUserList/AdminUserList';
import AdminUserSingle from './pages/admin/AdminUserSingle/AdminUserSingle';
import AdminClubList from './pages/admin/AdminClubList/AdminClubList';
import AdminClubSingle from './pages/admin/AdminClubSingle/AdminClubSingle';
import AdminPostList from './pages/admin/AdminPostList/AdminPostList';
import AdminPostSingle from './pages/admin/AdminPostSingle/AdminPostSingle';
import AdminProductList from './pages/admin/AdminProductList/AdminProductList';
import AdminProductSingle from './pages/admin/AdminProductSingle/AdminProductSingle';
import AdminDiscountList from './pages/admin/AdminDiscountList/AdminDiscountList';
import AdminDiscountSingle from './pages/admin/AdminDiscountSingle/AdminDiscountSingle';
import AdminCommentList from './pages/admin/AdminCommentList/AdminCommentList';
import AdminCommentSingle from './pages/admin/AdminCommentSingle/AdminCommentSingle';
import AdminTournamentList from './pages/admin/AdminTournamentList/AdminTournamentList';
import AdminLeagues from './pages/admin/AdminLeagues/AdminLeagues';
import AdminCountryList from './pages/admin/AdminCountryList/AdminCountryList';
import AdminExerciseList from './pages/admin/AdminExerciseList/AdminExerciseList';
import AdminExerciseSingle from './pages/admin/AdminExerciseSingle/AdminExerciseSingle';
import AdminExerciseCreate from './pages/admin/AdminExerciseCreate/AdminExerciseCreate';
import AdminCityList from './pages/admin/AdminCityList/AdminCityList';
import AdminCityCreate from './pages/admin/AdminCityCreate/AdminCityCreate';
import AdminCitySingle from './pages/admin/AdminCitySingle/AdminCitySingle';

function App() {
  let routes = useRoutes([
    {
      path: '*',
      element: <NotFound />,
    },
    {
      path: '/admin/banner/update/:slug',
      element: (
        <AdminLayout>
          <AdminBannerUpdate />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/banner/create',
      element: (
        <AdminLayout>
          <AdminBannerCreate />
        </AdminLayout>
      ),
    },

    {
      path: 'admin/banners',
      element: (
        <AdminLayout>
          <AdminBannerList />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/support/update/:slug',
      element: (
        <AdminLayout>
          <AdminSupportUpdate />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/support/create',
      element: (
        <AdminLayout>
          <AdminSupportCreate />
        </AdminLayout>
      ),
    },

    {
      path: 'admin/support-list',
      element: (
        <AdminLayout>
          <AdminSupportList />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/parent-game/update/:slug',
      element: (
        <AdminLayout>
          <AdminParentGameUpdate />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/parent-game/create',
      element: (
        <AdminLayout>
          <AdminParentGameCreate />
        </AdminLayout>
      ),
    },

    {
      path: 'admin/parent-games',
      element: (
        <AdminLayout>
          <AdminParentGameList />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/game/update/:slug',
      element: (
        <AdminLayout>
          <AdminGameUpdate />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/game/create',
      element: (
        <AdminLayout>
          <AdminGameCreate />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/orders',
      element: (
        <AdminLayout>
          <AdminOrderList />
        </AdminLayout>
      ),
    },

    {
      path: '/admin/games',
      element: (
        <AdminLayout>
          <AdminGameList />
        </AdminLayout>
      ),
    },
    {
      path: '/',
      element: <AdminLogin />,
    },
    {
      path: '/admin/users',
      element: (
        <AdminLayout>
          <AdminUserList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/posts',
      element: (
        <AdminLayout>
          <AdminPostList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/clubs',
      element: (
        <AdminLayout>
          <AdminClubList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/exercises',
      element: (
        <AdminLayout>
          <AdminExerciseList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/city/list',
      element: (
        <AdminLayout>
          <AdminCityList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/city/create',
      element: (
        <AdminLayout>
          <AdminCityCreate />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/products',
      element: (
        <AdminLayout>
          <AdminProductList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/promotions',
      element: (
        <AdminLayout>
          <AdminDiscountList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/countries',
      element: (
        <AdminLayout>
          <AdminCountryList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/comments',
      element: (
        <AdminLayout>
          <AdminCommentList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/tournaments',
      element: (
        <AdminLayout>
          <AdminTournamentList />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/product/edit/:id',
      element: (
        <AdminLayout>
          <AdminProductSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/comment/edit/:id',
      element: (
        <AdminLayout>
          <AdminCommentSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/user/edit/:id',
      element: (
        <AdminLayout>
          <AdminUserSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/post/edit/:id',
      element: (
        <AdminLayout>
          <AdminPostSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/city/edit/:id',
      element: (
        <AdminLayout>
          <AdminCitySingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/club/edit/:id',
      element: (
        <AdminLayout>
          <AdminClubSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/exercise/edit/:id',
      element: (
        <AdminLayout>
          <AdminExerciseSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/exercise/create',
      element: (
        <AdminLayout>
          <AdminExerciseCreate />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/promotion/edit/:id',
      element: (
        <AdminLayout>
          <AdminDiscountSingle />
        </AdminLayout>
      ),
    },
    {
      path: '/admin/leagues',
      element: (
        <AdminLayout>
          <AdminLeagues />
        </AdminLayout>
      ),
    },
    // {
    //   path: '/admin',
    //   element: <Navigate to="/admin/orders" />,
    // },
  ]);

  return routes;
}

export default App;
